<template>
  <div>

    <div class="statusBarBox" ref="barBox">
      <div class="bavBar" :style="{height:statusBarHeight+'px'}"></div>
      <div class="statusBarBox1" v-if="placeHolder">
        <div class="left-section">
          <i @click="goBack" class="el-icon-arrow-left"></i>
        </div>
        <div class="center-title">{{ name }}</div>
        <div class="right-section">
          <slot name="right"></slot>
        </div>
      </div>
      
    </div>
    <div :style="{height:placeHolderHeight+'px'}"></div>
  </div>
</template>
<script>
import {mapGetters} from "vuex";
import {nextTick} from "vue";

export default {
  name: "statusBar",
  props: {
    placeHolder: {
      type: Boolean,
      default: true
    }
  }

  ,
  computed: {
    ...mapGetters(['statusBarHeight'])
  },
  data() {
    return {
      name: '',
      placeHolderHeight: 0
    }
  }
  ,
  watch: {
    $route: {
      handler: function (n) {
        this.name = n.meta.title
      },
      immediate: true
    }
  },
  mounted() {
    nextTick(() => {
      let element = this.$refs.barBox;
      if (element) {
        // console.log(element.offsetHeight);
        this.placeHolderHeight = element.offsetHeight
      } else {
        console.log('没有找到ref为barBox的元素');
      }
    })
  },
  methods: {
    goBack() {
      this.$router.back()
    }
  }
}
</script>

<style scoped lang="scss">
.statusBarBox {
  background-color: #f1f2f4;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 999;

  .statusBarBox1 {
    display: flex;
    color: black;
    align-items: center;
    line-height: 40px;
    padding: 0 10px;
    position: relative;
    height: 40px;
    
    .left-section {
      width: 30px;
      flex-shrink: 0;
      z-index: 2;
    }
    
    .center-title {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      text-align: center;
      font-weight: bold;
      white-space: nowrap;
      z-index: 1;
    }
    
    .right-section {
      margin-left: auto;
      flex-shrink: 0;
      z-index: 2;
    }
  }
}
</style>
